import { Skeleton, TableRow } from '@mui/material';

import { SkeletonCell } from './table-styles';

interface TableSkeletonProps {
  rowsPerPage: number;
  columns: number;
}

export const TableSkeleton = ({
  rowsPerPage,
  columns,
}: TableSkeletonProps): JSX.Element => (
  <>
    {Array.from({ length: rowsPerPage }).map((_, rowIndex) => (
      <TableRow key={`skeleton-row-${rowIndex + "1"}`}>
        {Array.from({ length: columns }).map((_item, cellIndex) => (
          <SkeletonCell key={`skeleton-cell-${rowIndex + "1"}-${cellIndex + "1"}`}>
            <Skeleton animation="wave" />
          </SkeletonCell>
        ))}
      </TableRow>
    ))}
  </>
);
